class RoleList {
  constructor() {
    this.RoleName = [];
    this.RoleDescription = [];
    this.RoleEnabled = false;
    this.UserType = [];
    this.Status = [];
    this.totalRecords = 0;
    this.RoleListResp = null;
  }

  getRoleName(index) {
    return this.RoleName[index];
  }

  setRoleName(index, RoleName) {
    this.RoleName[index] = RoleName;
  }

  getRoleDescription(index) {
    return this.RoleDescription[index];
  }

  setRoleDescription(index, RoleDescription) {
    this.RoleDescription[index] = RoleDescription;
  }

  getRoleEnabled(index) {
    return this.RoleEnabled[index];
  }

  setRoleEnabled(index, RoleEnabled) {
    this.RoleEnabled[index] = RoleEnabled;
  }

  getUserType(index) {
    return this.UserType[index];
  }

  setUserType(index, UserType) {
    this.UserType[index] = UserType;
  }

  getStatus(index) {
    return this.Status[index];
  }

  setStatus(index, Status) {
    this.Status[index] = Status;
  }

  getRoleListResp() {
    return this.RoleListResp;
  }

  setRoleListResp(RoleListResp) {
    this.RoleListResp = RoleListResp;
  }

  getTotalRecords() {
    return this.totalRecords;
  }

  setTotalRecords(totalRecords) {
    this.totalRecords = totalRecords;
  }

  resetRoleList() {
    this.RoleName = [];
    this.RoleDescription = [];
    this.RoleEnabled = false;
    this.UserType = [];
    this.Status = [];
    this.totalRecords = 0;
    this.RoleListResp = null;
  }
}
export default new RoleList();
